import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "../../auth/hooks/useAuth";

const useWar = params => {
  const [settings, setSettings] = useState();
  const [subs, setSubs] = useState();
  const [status, setStatus] = useState();
  const { state: authState } = useAuth();
  const [upcomingWar, setUpcomingWar] = useState(null);

  useEffect(() => {
    console.log("SETTIN");
    console.log(settings);
    if (settings != null){
        try {
            (async () => {
            //setStatus("LOADING");
            console.log(process.env.REACT_APP_API);
            const response2 = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API}/reworked/getwarsubs`,
                params,
                headers: {
                Authorization: `Bearer ${authState.access_token}`
                },
                data: {
                "war_id": settings.id
                }
            });
            console.log(response2.data)
            //FILTER FIRST
            response2.data.sort(function(a, b) {
              return b.total_correct - a.total_correct;
            });
            setSubs(response2.data);
            //setSettings(response.data);
            //setStatus("OK");
            })();
        } catch (e) {
            setStatus("ERROR");
            console.log("error")
        }
    }
      
}, [settings]);



useEffect(() => {
  console.log("get upcoming war");
  console.log(upcomingWar);
  if (settings == null && upcomingWar == null){
      try {
        (async () => {
          setStatus("LOADING");
          console.log("getting upcoming war");
          const response = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API}/getupcomingwar`,
            params,
            headers: {
              Authorization: `Bearer ${authState.access_token}`
            }
          });
          console.log("war data");
          console.log(response.data)
          setUpcomingWar(response.data);
          setStatus("OK");
        })();
      } catch (e) {
        setStatus("ERROR");
        console.log("error")
      }
  }
    
}, [upcomingWar]);



  useEffect(() => {
    try {
      (async () => {
        setStatus("LOADING");
        console.log(process.env.REACT_APP_API);
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API}/getwar`,
          params,
          headers: {
            Authorization: `Bearer ${authState.access_token}`
          }
        });
        console.log(response.data)
        setSettings(response.data);
        if(settings !== undefined)
        {
            console.log(settings);
            //get war subs
            try{
                console.log("fnaf");
            }catch (e2){
                console.log(e2);
            }
        }
        setStatus("OK");
      })();
    } catch (e) {
      setStatus("ERROR");
      console.log("error")
    }
  }, []);
  console.log(settings);
    return {
      settings,
      status,
      upcomingWar,
      subs
    };
};

export default useWar;
